var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseHistoryIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.875 7.75C20.6009 7.75 22 6.35089 22 4.625C22 2.89911 20.6009 1.5 18.875 1.5C17.1491 1.5 15.75 2.89911 15.75 4.625C15.75 6.35089 17.1491 7.75 18.875 7.75Z",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0859 6.83398L23.2509 8.99998",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.5H2.25C1.42157 7.5 0.75 6.82843 0.75 6V4.5C0.75 3.67157 1.42157 3 2.25 3H12.75",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 11.25C2.83211 11.25 3 11.4179 3 11.625C3 11.8321 2.83211 12 2.625 12C2.41789 12 2.25 11.8321 2.25 11.625C2.25 11.4179 2.41789 11.25 2.625 11.25",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H18",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 16.5C2.83211 16.5 3 16.6679 3 16.875C3 17.0821 2.83211 17.25 2.625 17.25C2.41789 17.25 2.25 17.0821 2.25 16.875C2.25 16.6679 2.41789 16.5 2.625 16.5",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.25H18",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 21.75C2.83211 21.75 3 21.9179 3 22.125C3 22.3321 2.83211 22.5 2.625 22.5C2.41789 22.5 2.25 22.3321 2.25 22.125C2.25 21.9179 2.41789 21.75 2.625 21.75",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.5H18",
    stroke: "#074B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseHistoryIconBlue);
export default __webpack_public_path__ + "static/media/purchase-history-icon-blue.7cf8df831fa9410b7da16f8c4f5b3bbc.svg";
export { ForwardRef as ReactComponent };